import fails$1 from './fails.js';
import wellKnownSymbol$1 from './well-known-symbol.js';
import engineV8Version from './engine-v8-version.js';

var fails = fails$1;
var wellKnownSymbol = wellKnownSymbol$1;
var V8_VERSION = engineV8Version;
var SPECIES = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};

    constructor[SPECIES] = function () {
      return {
        foo: 1
      };
    };

    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

export { arrayMethodHasSpeciesSupport as default };
